<footer class="content-footer footer bg-footer-theme">
    <div class="container-fluid d-flex flex-wrap justify-content-between py-2 flex-md-row flex-column">
      <div class="mb-2 mb-md-0">
        {{'Design and implementation' | translate}} 
        <a href="https://rtl-theme.com" target="_blank" class="footer-link fw-semibold">{{'PendarPajouh' | translate}}</a>
      </div>
      <div>
        <a href="https://rtl-theme.com" class="footer-link me-4" target="_blank">{{'License' | translate}}</a>
        <a href="https://rtl-theme.com" target="_blank" class="footer-link me-4">{{'More' | translate}}</a>

        <a href="https://v3dboy.ir/previews/html/frest/documentation" target="_blank" class="footer-link me-4">{{'Doc' | translate}}</a>

        <a href="https://rtl-theme.com" target="_blank" class="footer-link d-none d-sm-inline-block">{{'Service' | translate}}</a>
      </div>
    </div>
  </footer>